module.exports = __webpack_public_path__ + "static/media/Sabbir_02.8e139166.jpg";